import { userMetaDataKeys } from '@inbox-demo-nx/constants';
import { View } from 'dripsy';
import { ReactElement } from 'react';
import { ImageProps, StyleProp, ViewStyle } from 'react-native';

import BrandAvatar from './BrandAvatar';
import ImageAvatar from './ImageAvatar';

function getRandomAvatarUrl(userId: string) {
  return `https://avatars.dicebear.com/api/miniavs/${userId}.png`;
}

export default function Avatar({
  size,
  style,
  user,
  fallbackAvatarKey,
  defaultBrandAvatar,
  ...props
}: {
  size: number;
  style?: StyleProp<ViewStyle>;
  user?: SendBird.User;
  fallbackAvatarKey?: string;
  defaultBrandAvatar?: ReactElement;
} & Omit<ImageProps, 'source'>) {
  if (!user) {
    if (fallbackAvatarKey) {
      return (
        <ImageAvatar
          source={{ uri: getRandomAvatarUrl(fallbackAvatarKey) }}
          size={size}
          style={style}
          {...props}
        />
      );
    }
    if (defaultBrandAvatar) {
      return defaultBrandAvatar;
    }
    return <View sx={{ width: size, height: size }} style={style} />;
  }

  if (user.metaData[userMetaDataKeys.brandAvatarType] === 'notifications') {
    return <BrandAvatar type="notifications" style={style} size={size} />;
  }
  if (user.metaData[userMetaDataKeys.brandAvatarType] === 'support') {
    return <BrandAvatar type="support" style={style} size={size} />;
  }

  if (user.metaData[userMetaDataKeys.brandAvatarType] === 'promotions') {
    return <BrandAvatar type="promotions" style={style} size={size} />;
  }
  if (user.metaData[userMetaDataKeys.brandAvatarType] === 'delivery') {
    return <BrandAvatar type="delivery" style={style} size={size} />;
  }

  return (
    <ImageAvatar
      source={{
        uri:
          user.profileUrl ||
          user.plainProfileUrl ||
          getRandomAvatarUrl(user.userId),
      }}
      size={size}
      style={style}
      {...props}
    />
  );
}
